@if (showLoading()) {
    <mat-progress-bar mode="indeterminate" ></mat-progress-bar>
}
